import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CheckCorrectPhoneNumber, ComparePhone } from "./phone.validator";
@Injectable({
  providedIn: 'root'
})
export class HelperService {
  addressKeys = [
    { label: 'ที่อยู่ตามบัตรประชาชน', value: 'ADDRESS_CITIZEN_ID' },
    { label: 'ที่อยู่ที่ตั้งตู้/ร้านค้า', value: 'ADDRESS_PRODUCT' },
    { label: 'ที่อยู่ที่จัดส่งเอกสาร', value: 'ADDRESS_DOCUMENT' },
  ];

  constructor(private fb: FormBuilder,
    public snackBar: MatSnackBar) {
  }

  openCompleteSnackBar() {
    let config = new MatSnackBarConfig();
    config.panelClass = ['snackbar-complete'];
    config.duration = 3000;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    this.snackBar.open('บันทึกเสร็จสมบูรณ์', "x", config);
  }

  openCompleteSnackBarWithMessage(message: string) {
    let config = new MatSnackBarConfig();
    config.panelClass = ['snackbar-complete'];
    config.duration = 3000;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    this.snackBar.open(message, "x", config);
  }

  openErrorSnackBar(message: string, duration = 5000) {
    let config = new MatSnackBarConfig();
    config.panelClass = ['snackbar-error'];
    config.duration = duration;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    this.snackBar.open(message, "x", config);
  }

  openUnknowErrorSnackBar() {
    let config = new MatSnackBarConfig();
    config.panelClass = ['snackbar-error'];
    config.duration = 5000;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    this.snackBar.open("พบข้อผิดพลาดในการบันทึกข้อมูล, กรุณาติดต่อผู้ดูแลระบบ!", "x", config);
  }

  createUtcDate(str?): Date {
    let obj;
    if (!str) {
      obj = new Date();
    } else {
      obj = new Date(str);
    }

    // hack for safari
    // it can create date from 'Y-m-d H:i:s', it only create for 'Y-m-d'
    if (isNaN(obj.getTime()) && typeof str === 'string') {
      const matchResult = str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/);
      if (matchResult) {
        obj = new Date(`${matchResult[1]}-${matchResult[2]}-${matchResult[3]}`);
      }
    }

    const day = obj.getDate();
    const month = obj.getMonth();
    const year = obj.getFullYear();

    return new Date(Date.UTC(year, month, day));
  }

  initFormAddresses(readonly: boolean = false): FormArray {
    const formArr = this.fb.array([]) as FormArray;

    for (const key of this.addressKeys) {
      const tmpForm = this.initFormAddress(readonly);
      tmpForm.get('key').setValue(key.value);
      tmpForm.get('label').setValue(key.label);
      formArr.push(tmpForm);
    }

    return formArr;
  }

  initFormAddress(readonly: boolean = false): FormGroup {
    return this.fb.group({
      id: [{ value: -1, disabled: readonly }],
      key: [{ value: '', disabled: readonly }],
      label: [{ value: '', disabled: readonly }],
      addressNo: [{ value: '', disabled: readonly }, Validators.required],
      moo: [{ value: '', disabled: readonly }],
      soi: [{ value: '', disabled: readonly }],
      building: [{ value: '', disabled: readonly }],
      floorNo: [{ value: '', disabled: readonly }],
      roomNo: [{ value: '', disabled: readonly }],
      road: [{ value: '', disabled: readonly }],

      provinceId: [{ value: -1, disabled: readonly }],
      districtId: [{ value: -1, disabled: readonly }],
      subDistrictId: [{ value: -1, disabled: readonly }],

      postcode: [{ value: '', disabled: readonly }, Validators.required],
      latitude: [{ value: '', disabled: readonly }],
      longitude: [{ value: '', disabled: readonly }],

      sub_district_code: [{ value: '', disabled: readonly  }, Validators.required],
      sub_district_name_th: [{ value: '', disabled: readonly  }],
      district_code: [{ value: '', disabled: readonly }, Validators.required],
      district_name_th: [{ value: '', disabled: readonly  }],
      province_code: [{ value: '', disabled: readonly  }, Validators.required],
      province_name_th: [{ value: '', disabled: readonly  }],
      location_code: [{ value: '', disabled: readonly }],

    });
  }

  initFormAttachment(): FormGroup {
    return this.fb.group({
      id: [-1],
      companyId: [''],
      documentId: [-1],
      documentName: [''],
      fileName: [''],
      documentType: [''],
      url: [''],
      label: [''],
      key: [''],
      isVerified: [false, Validators.required],
      isRequired: [false, Validators.required]
    });
  }

  initFormCustomer(customerType: number, readonly: boolean = false): FormGroup {
    return this.fb.group({
      id: [{ value: -1, disabled: readonly }],
      //name: ['', Validators.required],
      type: [{ value: customerType, disabled: readonly }],
      identityNo: [{ value: '', disabled: readonly }, Validators.compose([
        Validators.required,
        Validators.minLength(13),
        Validators.maxLength(13),
      ])],
      primaryPhone: [{ value: '', disabled: readonly }, Validators.compose([
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(10),
      ])],
        //  secondaryPhone: [{ value: '', disabled: readonly }],
      secondaryPhone: [{ value: '', disabled: readonly }, Validators.compose([
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(10),
      ])],
      prefix: [{ value: '', disabled: readonly }],
      firstName: [{ value: '', disabled: readonly }, Validators.compose([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(150)
      ])],
      lastName: [{ value: '', disabled: readonly }, Validators.compose([
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(150)
      ])],
      dateOfBirth: [{ value: this.createUtcDate(), disabled: readonly }, Validators.required],
      age: [{ value: '0 ปี 0 เดือน', disabled: readonly }],

      lineId :  [''],
      email :  ['',Validators.email],
    },
    {
      validator: [ComparePhone("primaryPhone","secondaryPhone"), CheckCorrectPhoneNumber("primaryPhone"), CheckCorrectPhoneNumber("secondaryPhone")]
    });
  }
}
